import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../mock'
import axios from 'axios.js'

const logAuthError = (err) => console.error('Auth API request failed', err?.response?.status || err?.message || 'unknown')


// FOLLOWING CODES ARE MOCK SERVER IMPLEMENTATION
// YOU NEED TO BUILD YOUR OWN SERVER
// IF YOU NEED HELP ABOUT SERVER SIDE IMPLEMENTATION
// CONTACT US AT support@ui-lib.com

Mock.onPost('/api/auth/login').reply(async (config) => {
    try {
        await new Promise((resolve) => setTimeout(resolve, 1000))
        const { email, password } = JSON.parse(config.data);

        const response = await axios.post(buildApiUrl('auth/login/'), {
            email,
            password,
        })
        const { data } = response.data

        const user = data;


        // const user = userList.find((u) => u.email === email & u.password === password)
        //
        // if(error == 'undefined'){
        //
        // }else{
        //     return [400, { message: errorInfo }];
        // }

        if (!user) {
            return [400, { message: 'Не верный Email или пароль' }]
        }
        // const accessToken = jwt.sign({ userId: user.id }, JWT_SECRET, {
        //     expiresIn: JWT_VALIDITY,
        // })

        const accessToken = user.accessToken;

        return [
            200,
            {
                accessToken,
                user: {
                    id: user.id,
                    id_parent: user.id_parent,
                    MainId: user.MainId,
                    avatar: user.avatar,
                    email: user.email,
                    name: user.name,
                    role: user.role,
                    typeAccount: normalizeTypeAccount(user.typeAccount ?? user.type_account),
                    isSuperAdmin: !!(user?.isSuperAdmin || user?.is_superadmin === 1 || user?.is_superadmin === true),
                    is_superadmin: user?.is_superadmin ?? (user?.isSuperAdmin ? 1 : 0),

                },
            },
        ]
    } catch (err) {
        logAuthError(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onPost('/api/auth/register').reply((config) => {
    try {
        const {
            email,
            username,
            password,
            agreement1,
            agreement2,
            agreement3,
            accept_source,
        } = JSON.parse(config.data)
        return axios.post(buildApiUrl('auth/register/'), {
            email,
            username,
            password,
            agreement1: !!agreement1,
            agreement2: !!agreement2,
            agreement3: !!agreement3,
            accept_source: accept_source || 'web_register',
        }).then((response) => {
            const payload = response.data || {}
            const { error, errorInfo, data, result, message } = payload
            if (error) {
                return [400, { message: errorInfo || 'Ошибка регистрации' }]
            }
            if (result !== 'success' || !data || !data.accessToken || !data.user || !data.user.id) {
                return [400, { message: message || 'Регистрация не завершена: некорректный ответ сервера' }]
            }
            return [200, {
                accessToken: data.accessToken,
                user: {
                    ...data.user,
                    isSuperAdmin: !!(data?.user?.isSuperAdmin || data?.user?.is_superadmin === 1 || data?.user?.is_superadmin === true),
                    is_superadmin: data?.user?.is_superadmin ?? (data?.user?.isSuperAdmin ? 1 : 0),
                },
            }]
        }).catch((err) => {
            logAuthError(err)
            return [500, { message: 'Internal server error' }]
        })
    } catch (err) {
        logAuthError(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onPost('/api/auth/forgot-password/request').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(buildApiUrl('auth/forgot-password/request/'), data || {})
        return [200, response?.data || {}]
    } catch (err) {
        logAuthError(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onPost('/api/auth/forgot-password/reset').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(buildApiUrl('auth/forgot-password/reset/'), data || {})
        return [200, response?.data || {}]
    } catch (err) {
        logAuthError(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onGet('/api/auth/profile').reply(async (config) => {
    try {
        const { Authorization } = config.headers

        if (!Authorization) {
            return [401, { message: 'Invalid Authorization token' }]
        }

        const response = await axios.post(buildApiUrl('user/profile/'), {}, {
            headers: { Authorization },
        })

        // const response = await axios.get(buildApiUrl('user/profil/?userId='+userId),{})
        const { data } = response.data

        // const user = userList.find((u) => u.id === userId)
        const user = data;

        if (!user) {
            return [401, { message: 'Invalid authorization token' }]
        }

        return [
            200,
            {
                user: {
                    id: user.id,
                    id_parent: user.id_parent ?? user.idParent ?? null,
                    MainId: user.MainId ?? user.mainId ?? null,
                    avatar: user.avatar,
                    email: user.email,
                    name: user.name,
                    role: user.role,
                    typeAccount: normalizeTypeAccount(user.typeAccount ?? user.type_account),
                    accessPage: normalizeAccessPage(user.accessPage ?? user.access_page),
                    affiliate: user.affiliate ?? user.id_affiliate ?? null,
                    outlets: user.outlets ?? user.id_points ?? null,
                    isSuperAdmin: !!(user?.isSuperAdmin || user?.is_superadmin === 1 || user?.is_superadmin === true),
                    is_superadmin: user?.is_superadmin ?? (user?.isSuperAdmin ? 1 : 0),
                    // Прокидываем mapSettings как от бэка, чтобы ключ карт подтягивался в профиль
                    mapSettings: {
                        ...(user.mapSettings || {}),
                        yandexApiKey: user?.mapSettings?.yandexApiKey
                            || user?.yandex_api_key
                            || user?.yandexApiKey
                            || null,
                        deliveryZones: user?.mapSettings?.deliveryZones || user?.deliveryZones || [],
                        barcodeSettings: user?.mapSettings?.barcodeSettings || user?.barcode_settings || {
                            prefix: '21',
                            body_from: 'art',
                            body_length: 10,
                            piece_prefix: '21',
                            weight_prefix: '22',
                            art_length: 5,
                            weight_length: 5,
                            weight_decimals: 3,
                            scan_mode: 'both',
                        },
                        retailOrderSettings: user?.mapSettings?.retailOrderSettings || user?.retail_order_settings || undefined,
                    },
                },
            },
        ]
    } catch (err) {
        logAuthError(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onGet('/api/auth/legal').reply(async () => {
    try {
        const response = await axios.get(buildApiUrl('auth/legal/get/'))
        return [200, response?.data || {}]
    } catch (err) {
        logAuthError(err)
        return [500, { message: 'Internal server error' }]
    }
})

Mock.onPost('/api/auth/legal/revoke-marketing').reply(async (config) => {
    try {
        const data = config?.data ? JSON.parse(config.data) : {}
        const response = await axios.post(buildApiUrl('auth/legal/revoke-marketing/'), data || {}, config)
        return [200, response?.data || {}]
    } catch (err) {
        logAuthError(err)
        return [500, { message: 'Internal server error' }]
    }
})
const normalizeTypeAccount = (raw) => {
    if (typeof raw === 'string') {
        const t = raw.trim().toLowerCase()
        if (!t) return 'fastfood'
        if (t === 'fastfood' || t === 'flower_shop') return t
        if (t === 'fast_food') return 'fastfood'
        if (t === '1') return 'fastfood'
        if (t === '2') return 'flower_shop'
        return t
    }
    if (typeof raw === 'number') {
        if (raw === 1) return 'fastfood'
        if (raw === 2) return 'flower_shop'
    }
    if (raw && typeof raw === 'object') {
        if (typeof raw.name === 'string' && raw.name.trim()) {
            return normalizeTypeAccount(raw.name)
        }
        if (typeof raw.type === 'string' && raw.type.trim()) {
            return normalizeTypeAccount(raw.type)
        }
        // если пришла ошибка из TA.getTypeAccount()
        return 'fastfood'
    }
    return 'fastfood'
}

const normalizeAccessPage = (raw) => {
    if (Array.isArray(raw)) return raw
    if (typeof raw === 'string') {
        const text = raw.trim()
        if (!text) return []
        try {
            const parsed = JSON.parse(text)
            return Array.isArray(parsed) ? parsed : []
        } catch (e) {
            return []
        }
    }
    return []
}
